import { DeleteFilled, EditFilled } from "@ant-design/icons";
import { Table as AntdTable, Popconfirm, Switch } from "antd";
import type { StoreLocation } from "@/api/store-location";

type StoreLocationTableProps = {
  data?: StoreLocation[];
  loading?: boolean;
  handleEdit: (record: StoreLocation) => void;
  handleDelete: (id: number) => void;
  handleToggleActive: (record: StoreLocation) => void;
};

export default function Table({
  data,
  loading,
  handleEdit,
  handleDelete,
  handleToggleActive,
}: StoreLocationTableProps) {
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 60,
    },
    {
      title: "Tên cửa hàng",
      dataIndex: "name",
      key: "name",
      width: 200,
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      width: 300,
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
      key: "phone",
      width: 120,
    },
    {
      title: "Giờ mở cửa",
      dataIndex: "hours",
      key: "hours",
      width: 150,
    },
    {
      title: "Google Maps",
      dataIndex: "mapUrl",
      key: "mapUrl",
      width: 150,
      render: (text: string) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 underline"
          >
            {text.length > 30 ? `${text.substring(0, 30)}...` : text}
          </a>
        ) : (
          "-"
        ),
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      key: "active",
      width: 100,
      render: (active: boolean, record: StoreLocation) => (
        <Switch
          checked={active}
          onChange={() => handleToggleActive(record)}
          checkedChildren="Hiện"
          unCheckedChildren="Ẩn"
        />
      ),
    },
    {
      key: "action",
      width: 80,
      render: (_: any, record: StoreLocation) => (
        <EditFilled
          className="cursor-pointer text-blue-500"
          onClick={() => handleEdit(record)}
        />
      ),
    },
  ];

  return (
    <div className="flex-1 overflow-auto">
      <AntdTable
        dataSource={data}
        loading={loading}
        rowKey="id"
        columns={columns}
        pagination={false}
      />
    </div>
  );
}
